import FlexPane from 'presentation/components/flex-pane/index.js';
import Text from 'presentation/components/text/index.js';
import Image from 'presentation/components/image/index.js';

export default function Notification(props) {
    const { text, children, class: className, mojitoTools } = props;
    const { config } = mojitoTools;

    return (
        <FlexPane config={config.container} class={className}>
            {config.icon.src && <Image config={config.icon} />}
            <Text config={config.text}>{text}</Text>
            {children}
        </FlexPane>
    );
}
